import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";

export default function UserRoute() {
  const { accessToken, type, status } = useAuthStore();
  const location = useLocation();

  if (!accessToken || type !== "candidate" || status !== true) {
    return <Navigate to={`/en/login/user/otp-verification`} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
